export default "__VITE_ASSET__DMsKFkWh__"